import i18n from '../i18n';
import { PLACEHOLDER_IMAGE_URL } from '../constants';

const enum DeliveryIntegrationsEnum {
    NOVAPOST = 'novapost',
    UKRPOSHTA = 'ukrposhta',
    ROZETKA = 'rozetka',
    MEEST = 'meest',
}

const CUSTOM_DELIVERY_METHOD = 'custom';

function showDeliveryIntegration(value: string): string {
    switch (value) {
        case DeliveryIntegrationsEnum.NOVAPOST:
            return i18n.global.t('delivery_integration.novapost');
        case DeliveryIntegrationsEnum.UKRPOSHTA:
            return i18n.global.t('delivery_integration.ukrposhta');
        case DeliveryIntegrationsEnum.ROZETKA:
            return i18n.global.t('delivery_integration.rozetka');
        case DeliveryIntegrationsEnum.MEEST:
            return i18n.global.t('delivery_integration.meest');
        default:
            return value;
    }
}

function getDeliveryIntegrationLogo(value: string): string {
    switch (value) {
        case DeliveryIntegrationsEnum.NOVAPOST:
            return '/img/delivery-methods/novapost.png';
        case DeliveryIntegrationsEnum.UKRPOSHTA:
            return '/img/delivery-methods/ukrposhta.png';
        case DeliveryIntegrationsEnum.ROZETKA:
            return '/img/delivery-methods/rozetka.png';
        case DeliveryIntegrationsEnum.MEEST:
            return '/img/delivery-methods/meest.png';
        default:
            return PLACEHOLDER_IMAGE_URL;
    }
}

export {
    CUSTOM_DELIVERY_METHOD,
    DeliveryIntegrationsEnum,
    showDeliveryIntegration,
    getDeliveryIntegrationLogo
};
